export const AVATAR = 'avatar';
export const DATA = 'data';
export const EMAIL = 'email';
export const FIRST_NAME = 'firstName';
export const ID = 'id';
export const LAST_NAME = 'lastName';
export const RECIPIENT_TYPE = 'recipientType';
export const STATUS = 'status';